import React from 'react';
import { hydrateRoot } from 'react-dom/client';
import { getAdvertiserNationFromSite } from './App/utils/AdvertiserNation';
import { BrowserRouter } from 'react-router-dom';
import { MelwaysProvider } from '@seek/melways-react';
import App from './App/App';
import type { ConfigOptions } from './render';

type ClientProps = {
  config: ConfigOptions;
};

export default ({ config }: ClientProps) => {
  const rootElement = document.getElementById('app');
  if (!rootElement) {
    throw new Error('Could not find root element');
  }
  hydrateRoot(
    rootElement,
    <MelwaysProvider.Client site={config.site}>
      <BrowserRouter>
        <App config={config} />
      </BrowserRouter>
    </MelwaysProvider.Client>,
  );
};
